import { useEffect } from 'react';

import Spinner from '@/ui/members/components/Spinner';

const Home = () => {
  useEffect(() => {
    window.location.href = `${process.env.VITE_APP_WEBSITE_URL}/download-and-schedule`;
  });

  return (
    <div className="flex flex-col items-center justify-center">
      <Spinner size={10} label="Loading..." />
    </div>
  );
};

export default Home;
